import { useCallback, useEffect, useMemo, useState } from 'react'
import { useNavigate } from 'react-router-dom'


import logo from "./img/logo.svg"
import axios from 'axios'
import classNames from 'classnames'
import GoogleSign from 'components/GoogleSign/GoogleSign'
import Stepper from 'components/Stepper/Stepper'
import { useStore } from 'store'
import { observer } from 'mobx-react-lite'
import { parseError } from 'utils/helpers'
// import './landing.module.scss'
// import './Landing.scss'
const companyTypes = [
    'Corporation',
    'LLC',
    'Partnership',
    'Sole Proprietorship',
    'Non-Profit',
    'Government Agency',
    'Healthcare Facility',
    'Insurance Company',
]

const PartnerSignup = () => {
    const navigate = useNavigate()
    const [termsAccept, setTermsAccept] = useState(false);
    const [termsError, setTermsError] = useState(false);
    const [isGoogleAuth, setIsGoogleAuth] = useState(false);
    const [companyName, setCompanyName] = useState('');
    const [companyType, setCompanyType] = useState('');
    const [ein, setEin] = useState('');
    const [name, setName] = useState('');
    const [surname, setSurname] = useState('');
    const [email, setEmail] = useState('');
    const [phone, setPhone] = useState('');
    const [isPhoneVerified, setIsPhoneVerified] = useState(false);
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [emailNotifications, setEmailNotifications] = useState(true);
    const [step, setStep] = useState(0)
    const [finishing, setFinishing] = useState(false);

    const store = useStore();

    const signInfo = useMemo(() => ({
        companyName,
        companyType,
        ein,
        name,
        surname,
        email,
        phone,
        isPhoneVerified,
        password,
        confirmPassword,
        emailNotifications,
    }), [
        companyName,
        companyType,
        ein,
        name,
        surname,
        email,
        phone,
        isPhoneVerified,
        password,
        confirmPassword,
        emailNotifications,
    ])

    const [error, setError] = useState({})


    useEffect(() => {
        document.body.classList.add("tailwind-body");

        return () => {
            document.body.classList.remove("tailwind-body");
        };
    }, []);


    const finishSignup = useCallback(() => {
        setFinishing(true)

        axios.post('/auth/signup/partner', signInfo)
            .then(({ data }) => {
                store.auth.authorize(data.token, 'partner');
                localStorage.setItem("hasSignedUp", true);
                navigate('/')
            })
            .catch((err) => {
                setStep(0)
                setError(parseError(err))
                setFinishing(false)
            })
    }, [signInfo, store, navigate])


    const startSignup = useCallback((e) => {
        e.preventDefault();

        if (!termsAccept) return setTermsError(true);
        setTermsError(false);

        if (!isGoogleAuth && signInfo.password !== signInfo.confirmPassword) {
            return setError({
                type: 'Password Error',
                message: 'Password and Confirm Password do not match'
            });
        }

        axios.post('/auth/signup/partner/validate', signInfo)
            .then(() => setStep(isGoogleAuth ? 2 : 1))
            .catch((err) => setError(parseError(err)));
    }, [signInfo, isGoogleAuth, termsAccept]);


    const googleSing = useCallback((data) => {
        if (data.email) {
            setIsGoogleAuth(true);
            setEmail(data.email);
            setPassword(null);
            if (data.given_name) setName(data.given_name);
            if (data.family_name) setSurname(data.family_name);
        }
    }, []);


    const onNextStep = useCallback(() => {
        if (step >= 2) {
            return finishSignup();
        } else {
            setStep((step) => step + 1);
        }
    }, [step, finishSignup]);

    return (
        <div className="min-h-screen bg-gray-50 flex flex-col justify-center py-12 sm:px-6 lg:px-8">
            {step === 0 && (
                <>
                    <div className="sm:mx-auto sm:w-full sm:max-w-md">
                        <a href="/" className="flex justify-center items-center space-x-2 mb-8">
                            <img
                                src={logo}
                                alt="Emissary Care"
                                className="h-12 w-auto"
                            />
                            <span className="text-xl font-semibold bg-gradient-to-r from-blue-500 via-sky-500 to-sky-700 bg-clip-text text-transparent">
                                Emissary Care
                            </span>
                        </a>
                        <h2 className="mt-6 text-center text-3xl font-bold tracking-tight bg-gradient-to-r from-blue-500 via-sky-500 to-sky-700 bg-clip-text text-transparent">
                            Create Partner Account
                        </h2>
                        <p className="mt-2 text-center text-sm text-gray-600">
                            Join our network of healthcare partners
                        </p>
                    </div>

                    <div className="mt-8 sm:mx-auto sm:w-full sm:max-w-md">
                        <div className="bg-white py-8 px-4 shadow sm:rounded-lg sm:px-10">
                            <form className="space-y-6" onSubmit={startSignup}>
                                <GoogleSign onUserInfo={googleSing} type="up" />
                                <div>
                                    <label htmlFor="companyName" className="block text-sm font-medium text-gray-700">
                                        Company Name
                                    </label>
                                    <div className="mt-1">
                                        <input
                                            id="companyName"
                                            name="companyName"
                                            type="text"
                                            required
                                            value={companyName}
                                            onChange={(e) => setCompanyName(e.target.value)}
                                            className="input-primary"
                                        />
                                    </div>
                                </div>

                                <div>
                                    <label htmlFor="companyType" className="block text-sm font-medium text-gray-700">
                                        Company Type
                                    </label>
                                    <div className="mt-1">
                                        <select
                                            id="companyType"
                                            name="companyType"
                                            required
                                            value={companyType}
                                            onChange={(e) => setCompanyType(e.target.value)}
                                            className="input-primary p-1"
                                        >
                                            <option value="">Select a type...</option>
                                            {companyTypes.map((type) => (
                                                <option key={type} value={type}>
                                                    {type}
                                                </option>
                                            ))}
                                        </select>
                                    </div>
                                </div>

                                <div>
                                    <label htmlFor="ein" className="block text-sm font-medium text-gray-700">
                                        Employee Identification Number (EIN)
                                    </label>
                                    <div className="mt-1">
                                        <input
                                            id="ein"
                                            name="ein"
                                            type="text"
                                            required
                                            value={ein}
                                            onChange={(e) => setEin(e.target.value)}
                                            className="input-primary"
                                            placeholder="XX-XXXXXXX"
                                        />
                                    </div>
                                </div>

                                <div className="grid grid-cols-1 gap-6 sm:grid-cols-2">
                                    <div>
                                        <label htmlFor="contactFirstName" className="block text-sm font-medium text-gray-700">
                                            Contact First Name
                                        </label>
                                        <div className="mt-1">
                                            <input
                                                id="contactFirstName"
                                                name="contactFirstName"
                                                type="text"
                                                required
                                                value={name}
                                                onChange={(e) => setName(e.target.value)}
                                                className="input-primary"
                                            />
                                        </div>
                                    </div>

                                    <div>
                                        <label htmlFor="contactLastName" className="block text-sm font-medium text-gray-700">
                                            Contact Last Name
                                        </label>
                                        <div className="mt-1">
                                            <input
                                                id="contactLastName"
                                                name="contactLastName"
                                                type="text"
                                                required
                                                value={surname}
                                                onChange={(e) => setSurname(e.target.value)}
                                                className="input-primary"
                                            />
                                        </div>
                                    </div>
                                </div>

                                <div>
                                    <label htmlFor="email" className="block text-sm font-medium text-gray-700">
                                        Business Email
                                    </label>
                                    <div className="mt-1">
                                        <input
                                            id="email"
                                            name="email"
                                            type="email"
                                            autoComplete="email"
                                            required
                                            value={email}
                                            onChange={(e) => setEmail(e.target.value)}
                                            className="input-primary"
                                        />
                                    </div>
                                </div>

                                <div>
                                    <label htmlFor="phone" className="block text-sm font-medium text-gray-700">
                                        Business Phone
                                    </label>
                                    <div className="mt-1">
                                        <input
                                            id="phone"
                                            name="phone"
                                            type="tel"
                                            autoComplete="tel"
                                            required
                                            value={phone}
                                            onChange={(e) => setPhone(e.target.value)}
                                            className="input-primary"
                                        />
                                    </div>
                                </div>

                                {!isGoogleAuth &&
                                    <>
                                        <div>
                                            <label htmlFor="password" className="block text-sm font-medium text-gray-700">
                                                Password
                                            </label>
                                            <div className="mt-1">
                                                <input
                                                    id="password"
                                                    name="password"
                                                    type="password"
                                                    autoComplete="new-password"
                                                    required
                                                    value={password}
                                                    onChange={(e) => setPassword(e.target.value)}
                                                    className="input-primary"
                                                />
                                            </div>
                                        </div>

                                        <div>
                                            <label htmlFor="confirmPassword" className="block text-sm font-medium text-gray-700">
                                                Confirm Password
                                            </label>
                                            <div className="mt-1">
                                                <input
                                                    id="confirmPassword"
                                                    name="confirmPassword"
                                                    type="password"
                                                    autoComplete="new-password"
                                                    required
                                                    value={confirmPassword}
                                                    onChange={(e) => setConfirmPassword(e.target.value)}
                                                    className="input-primary"
                                                />
                                            </div>
                                        </div>
                                    </>}



                                <div className="flex items-center">
                                    <input
                                        id="emailNotifications"
                                        name="emailNotifications"
                                        type="checkbox"
                                        checked={emailNotifications}
                                        onChange={(e) => setEmailNotifications(e.target.checked)}
                                        className="h-4 w-4 text-blue-600 border-gray-300 rounded focus:ring-blue-500"
                                    />
                                    <label htmlFor="emailNotifications" className="ml-2 block text-sm text-gray-900">
                                        Receive email notifications for all bookings
                                    </label>
                                </div>

                                <div className="h-[20px]">
                                    {error.message && (
                                        <div className="text-red-600 text-sm text-center">
                                            <b>{error.type}</b> {error.message}
                                        </div>
                                    )}
                                </div>

                                <div className="mt-6">
                                    <label
                                        className={classNames(
                                            'flex items-start space-x-3 text-sm font-semibold text-gray-700 justify-center',
                                            { 'text-red-600': termsError }
                                        )}
                                    >
                                        <div className="flex items-center">
                                            <input
                                                type="checkbox"
                                                checked={termsAccept}
                                                onChange={(e) => {
                                                    setTermsAccept(e.target.checked)
                                                }}
                                                className=" h-4 w-4 text-blue-600 border-gray-300 rounded focus:ring-blue-500"
                                            />
                                            <label htmlFor="emailNotifications" className="ml-2 block text-sm text-gray-900">
                                                <div className="check"></div>I agree to the{' '}
                                                <a
                                                    href="https://emissary-health-storage.s3.amazonaws.com/Emissary_Health_Terms_of_Use_2023.pdf"
                                                    target="_blank"
                                                    rel="noreferrer"
                                                >Terms</a> and{' '}
                                                <a
                                                    href="https://emissary-health-storage.s3.amazonaws.com/Emissary_Health_Privacy_Policy_10.12.2023.pdf"
                                                    target="_blank"
                                                    rel="noreferrer"
                                                >Privacy Policy</a>
                                            </label>
                                        </div>
                                    </label>
                                </div>

                                <div>
                                    <button disabled={!termsAccept} type="submit" className="w-full btn-primary">
                                        Create Partner Account
                                    </button>
                                </div>

                                {/* <p className="mt-2 text-xs text-gray-500">
                            Your account will be reviewed by our team before approval. We'll notify you once your
                            account is activated.
                        </p> */}
                            </form>
                        </div>
                    </div>
                </>
            )}
            {step > 0 && !finishing &&
                <Stepper
                    step={step}
                    nextStep={onNextStep}
                    userType={'partner'}
                    signInfo={signInfo}
                    finish={finishSignup}
                    isGoogleAuth={isGoogleAuth}
                    setPhoneNumber={setPhone}
                    phoneNumber={phone}
                    setIsPhoneVerified={setIsPhoneVerified}
                />}
        </div>
    )
}

export default observer(PartnerSignup)